import { Routes } from '@angular/router';
import { ShowcaseComponent } from './components/showcase/showcase.component';
import { authenticationGuard } from './core/security/authentication.guard';
import { notAuthenticatedGuard } from './core/security/not-authenticated.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'private', pathMatch: 'full' },
  {
    path: 'authentication',
    canActivate: [notAuthenticatedGuard],
    loadComponent: () => import('./components/authentication/authentication.component').then((m) => m.AuthenticationComponent)
  },
  {
    path: 'private',
    canActivate: [authenticationGuard],
    loadComponent: () => import('./components/private/private.component').then((m) => m.PrivateComponent),
    loadChildren: () => import('./components/private/private.routes').then((m) => m.PrivatesRoutes)
  },
  {
    path: 'showcase',
    canActivate: [authenticationGuard],
    component: ShowcaseComponent
  },
  {
    path: 'help-cms',
    canActivate: [authenticationGuard],
    // Check if Role Marketing is on
    loadComponent: () => import('./components/help-cms/help-cms.component').then((m) => m.HelpCmsComponent)
  },
  { path: '**', redirectTo: 'private', pathMatch: 'full' }
];
